// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"478":"organization","590":"homeindex","632":"statics","675":"expert"}[chunkId] || chunkId) + ".1776415140102.js";
};